import React from 'react';
const nf = new Intl.NumberFormat();

class CalcApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstVal: '',
      secondVal: '',
      operator: '',
      display: '0',
    };
    this.getOverall = this.getOverall.bind(this);
    this.setNumberValue = this.setNumberValue.bind(this);
    this.keypressHandler = this.keypressHandler.bind(this);
    this.numberClickHandler = this.numberClickHandler.bind(this);
    this.operatorClickHandler = this.operatorClickHandler.bind(this);
    this.equalHandler = this.equalHandler.bind(this);
    this.deleteChar = this.deleteChar.bind(this);
    this.allClear = this.allClear.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keyup', this.keypressHandler);
  }
  componentWillUnmount() {
    document.removeEventListener('keyup', this.keypressHandler);
  }

  keypressHandler(ev) {
    const numRegex = /^([0-9]|\.)*$/g;
    const opRegex = /[+|\-|:|*]/g;
    const eqRegex = /(=)/g;
    const delRegex = /(Backspace|Delete)/g;
    const acRegex = /(Escape)/g;

    const key =
      ev.target.localName === 'input' || ev.target.name === 'specialNotes' ? null : ev.key;

    const isNumber = !!numRegex.exec(key);
    const isOperator = !!opRegex.exec(key);
    const isEqual = !!eqRegex.exec(key);
    const isDel = !!delRegex.exec(key);
    const isAc = !!acRegex.exec(key);

    if (this.state.display.length >= 13) {
      this.setNumberValue('');
      this.setOperatorValue('');
    }

    if (key && isNumber) {
      if (this.state.display.length >= 13) {
        this.setNumberValue('');
      } else {
        this.setNumberValue(key + '');
      }
    }

    if (key && isOperator) {
      if (this.state.display.length >= 13) {
        this.setOperatorValue('');
      } else {
        this.setOperatorValue(key + '');
      }
    }

    if (key && isEqual) {
      this.equalHandler();
    }

    if (key && isDel) {
      this.deleteChar();
    }

    if (key && isAc) {
      this.allClear();
    }
  }

  resetState(resetAll) {
    if (resetAll) {
      this.setState({
        firstVal: '',
        secondVal: '',
        operator: '',
        display: '0',
      });
    } else {
      this.setState({
        firstVal: '',
        secondVal: '',
        operator: '',
      });
    }
  }

  hasPoint(value) {
    return value.indexOf('.') > -1;
  }

  setNumberValue(value) {
    const {firstVal, secondVal, operator} = this.state;
    let total;

    // if point is pressed, check if we already have it in current states
    if (value === '.') {
      if (!operator && !this.hasPoint(firstVal)) {
        total = this.fixNumberString(firstVal + value);
        this.setState({
          firstVal: total,
        });
      }
      if (!!operator && !this.hasPoint(secondVal)) {
        total = this.fixNumberString(secondVal + value);
        // file deepcode ignore ReactNextState: <please specify a reason of ignoring this>
        this.setState({
          secondVal: total,
        });
      }
      if (total) {
        // setDisplay(total + "");
      }

      return;
    }

    // if input is a number, check if it's first or second number
    if (!operator) {
      total = this.fixNumberString(firstVal + value);
      this.setState({
        firstVal: total,
      });
    } else {
      total = this.fixNumberString(secondVal + value);
      this.setState({
        secondVal: total,
      });
    }
    // setDisplay(total + "");
  }

  getOverall() {
    const {firstVal, secondVal, operator} = this.state;
    const splitted = firstVal.split('');
    const last = splitted[splitted.length - 1];

    if (this.hasPoint(firstVal) && last === '.') {
      return nf.format(firstVal) + '.';
    } else {
      return (
        (firstVal === '' ? ' ' : nf.format(firstVal)) +
        operator +
        (secondVal === '' ? '' : nf.format(secondVal))
      );
    }
  }

  setDisplay(value) {
    this.setState({
      display: value,
    });
  }

  getCurrentTargetValue() {
    const {firstVal, secondVal, operator} = this.state;
    return !operator ? firstVal : secondVal;
  }

  numberClickHandler(e) {
    if (
      e.target.localName !== 'input' &&
      e.target.localName !== 'textarea' &&
      e.target.localName === 'button'
    ) {
      const value = e.target.innerHTML;
      if (value) {
        this.setNumberValue(value);
      }
    }
  }

  setOperatorValue(operatorInput) {
    const {firstVal, secondVal, operator, display} = this.state;

    if (firstVal && !secondVal) {
      this.setState({
        operator: operatorInput,
        // display: fixedNumber,
      });
    } else if (firstVal && operator && secondVal) {
      const total = this.calculate();
      this.setState({
        operator: operatorInput,
        firstVal: total.split(',').join(''),
        secondVal: '',
      });
      // setDisplay(total + "");
    } else {
      this.setState({
        operator: operatorInput,
        firstVal: this.fixNumberString(display.split(',').join(''), false),
      });
    }
  }

  operatorClickHandler(e) {
    const operatorInput = e.target.innerHTML;

    this.setOperatorValue(operatorInput);
  }

  allClear() {
    this.resetState(true);
  }

  deleteChar() {
    const {firstVal, secondVal, operator} = this.state;

    if (!operator) {
      const newVal = firstVal.slice(0, -1);
      this.setState({
        firstVal: newVal,
        // display: newVal ? newVal : "0",
      });
    } else if (operator && !secondVal) {
      this.setState({
        // display: firstVal,
        operator: '',
      });
    } else {
      const newVal = secondVal.slice(0, -1);
      this.setState({
        secondVal: newVal,
        // display: newVal ? newVal : "0",
      });
    }

    if (firstVal.length > 0 || secondVal.length > 0 || operator.length > 0) {
      return;
    } else {
      this.setState({
        display: this.state.display.slice(0, this.state.display.length - 1),
      });
    }
  }

  removeZeroAtStart(value) {
    return value.indexOf('0') === 0 ? value.substring(1) : value;
  }

  fixNumberString(value, finalize = false) {
    // if input has hanging point e.g. '0.'/'1.', add trailing zero
    // should only run when moving to second value / begin calculation
    if (finalize && value.indexOf('.') === value.length - 1 && value.length > 1) {
      return value + '0';
    }
    // if value has zero prefix but not a decimal value, e.g. '01'/'03', remove zero
    if (value.indexOf('0.') !== 0 && value.indexOf('0') === 0) {
      return value.substring(1);
    }
    // if value is a first point input '.', add zero prefix
    if (value.indexOf('.') === 0 && value.length === 1) {
      return '0.';
    }

    if (!value) {
      return '0';
    }
    return value;
  }

  calculate() {
    const {firstVal, secondVal, operator} = this.state;

    const vfirstVal = this.fixNumberString(firstVal, true);
    const vsecondVal = this.fixNumberString(secondVal, true);
    let total = '0';

    switch (operator) {
    case '-':
      total = parseFloat(vfirstVal) - parseFloat(vsecondVal);
      break;
    case '*':
      total = parseFloat(vfirstVal) * parseFloat(vsecondVal);
      break;
    case '/':
      total = parseFloat(vfirstVal) / parseFloat(vsecondVal);
      break;
    case '%':
      total = parseFloat(vfirstVal) % parseFloat(vsecondVal);
      break;
    case '+':
    default:
      total = parseFloat(vfirstVal) + parseFloat(vsecondVal);
      break;
    }

    return total.toLocaleString();
  }

  equalHandler() {
    const {firstVal, secondVal, operator} = this.state;

    if (firstVal && secondVal && operator) {
      const total = this.calculate();
      this.setDisplay(total + '');
      this.resetState();
    }
  }

  render() {
    const {display, operator} = this.state;

    // if(display.length >= 6 ){
    //   alert('limit is over')
    // }

    const activeOperator = (name) => {
      return operator === name ? 'active' : '';
    };

    return (
      <div>
        <div className="display">
          <p className="display-overall">{this.getOverall().trim()}</p>
          <p className="result">{display}</p>
        </div>
        <div className="inputs col-md-12">
          <div className="row first-row">
            <button className="delete" onClick={this.deleteChar}>
              C
            </button>
            <button className="clear" onClick={this.allClear}>
              AC
            </button>
            <button
              className={activeOperator('/')}
              onClick={this.operatorClickHandler}
              disabled={display.length >= 13}
            >
              /
            </button>
          </div>
          <div className="row second-row">
            <button className="digits" disabled={display.length >= 13} onClick={this.numberClickHandler}>
              7
            </button>
            <button className="digits" disabled={display.length >= 13} onClick={this.numberClickHandler}>
              8
            </button>
            <button className="digits" disabled={display.length >= 13} onClick={this.numberClickHandler}>
              9
            </button>
            <button
              className={activeOperator('*')}
              onClick={this.operatorClickHandler}
              disabled={display.length >= 13}
            >
              *
            </button>
          </div>
          <div className="row third-row">
            <button className="digits" onClick={this.numberClickHandler} disabled={display.length >= 13}>
              4
            </button>
            <button className="digits" disabled={display.length >= 13} onClick={this.numberClickHandler}>
              5
            </button>
            <button className="digits" disabled={display.length >= 13} onClick={this.numberClickHandler}>
              6
            </button>
            <button
              className={activeOperator('-')}
              onClick={this.operatorClickHandler}
              disabled={display.length >= 13}
            >
              -
            </button>
          </div>
          <div className="row fourth-row">
            <button className="digits" disabled={display.length >= 13} onClick={this.numberClickHandler}>
              1
            </button>
            <button className="digits" disabled={display.length >= 13} onClick={this.numberClickHandler}>
              2
            </button>
            <button className="digits" disabled={display.length >= 13} onClick={this.numberClickHandler}>
              3
            </button>
            <button
              className={activeOperator('+')}
              onClick={this.operatorClickHandler}
              disabled={display.length >= 13}
            >
              +
            </button>
          </div>
          <div className="row fifth-row">
            <button className="digits" onClick={this.numberClickHandler} disabled={display.length >= 13}>
              0
            </button>
            <button className="digits" onClick={this.numberClickHandler} disabled={display.length >= 13}>
              .
            </button>
            <button
              className={activeOperator('%')}
              onClick={this.operatorClickHandler}
              disabled={display.length >= 13}
            >
              %
            </button>
            <button className="equal" onClick={this.equalHandler}>
              =
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default CalcApp;
